import React from "react";
import { CalendarNavigation } from "./CalendarNavigation";
import { StatusLegend } from "./StatusLegend";

interface CalendarToolbarProps {
  onPreviousMonth: () => void;
  onNextMonth: () => void;
  onToday: () => void;
  onAddReport?: () => void;
  plannedReportsCount?: number;
  currentMonth: Date;
}

export const CalendarToolbar: React.FC<CalendarToolbarProps> = ({
  onPreviousMonth,
  onNextMonth,
  onToday,
  onAddReport,
  plannedReportsCount = 0,
  currentMonth,
}) => {
  const monthName = currentMonth.toLocaleDateString('pl-pl', { month: 'long', year: 'numeric' });
  
  return (
    <div className="sticky top-0 z-10 bg-[var(--sc-surface)] border-b border-[var(--sc-border)] py-3 mb-6 shadow-sm">
      <div className="flex items-center justify-between pl-2">
        <StatusLegend plannedReportsCount={plannedReportsCount} />
        <div className="flex items-center gap-6">
          <h2 className="text-[15px] font-semibold text-[var(--sc-text)]">{monthName}</h2>
          <CalendarNavigation
            onPreviousMonth={onPreviousMonth}
            onNextMonth={onNextMonth}
            onToday={onToday}
            onAddReport={onAddReport}
          />
        </div>
      </div>
    </div>
  );
};
